module.exports = __webpack_public_path__ + "3bb445743ba197513d04d8af8150db16.jpg";